<template>
  <b-modal
    id="edit-subscription-plan-modal"
    centered
    hide-footer
    title="Edit Subscription Plan"
  >

    <b-form-group label="Plan Name">
      <b-form-input v-model="name" />
    </b-form-group>

    <b-form-group label="Price">
      <b-form-input type="number" v-model="price" />
    </b-form-group>

    <b-form-group label="Lead Limit">
      <b-form-input type="number" v-model="lead_limit" />
    </b-form-group>

    <div class="text-right">
      <b-button variant="primary" @click="submit">
        Edit
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: { plan: Object },

  data() {
    return {
      name: "",
      price: 0,
      lead_limit: 0,
    };
  },

  mounted() {
    if (this.plan) {
      this.name = this.plan.name;
      this.price = this.plan.price;
      this.lead_limit = this.plan.lead_limit;
    }
  },

  methods: {
    ...mapActions("appData", ["updateSubscriptionPlan"]),

    async submit() {
      await this.updateSubscriptionPlan({
        pk: this.plan.id,
        payload: {
          name: this.name,
          price: this.price,
          lead_limit: this.lead_limit,
        },
      });

      this.$bvModal.hide("edit-subscription-plan-modal");
      this.$emit("modalClosed");
    },
  },
};
</script>